/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'stock': {
    width: 18,
    height: 16,
    viewBox: '0 0 18 16',
    data: '<path pid="0" d="M16.4 0c.355 0 .668.223.767.534l.023.096.77 4.35c.249 1.414-.598 2.763-1.96 3.289v5.971c0 1-.77 1.76-1.76 1.76H3.76C2.77 16 2 15.24 2 14.24V8.268C.824 7.811 0 6.728 0 5.47c0-.107.004-.218.016-.327L.04 4.98.81.63c.055-.327.34-.58.685-.623L1.6 0h14.8zm-4.52 7.21l-.14.15A3.8 3.8 0 019 8.5c-1.16 0-2.2-.5-2.88-1.29-.621.733-1.561 1.216-2.62 1.282v5.748c0 .14.11.26.26.26h10.48c.15 0 .26-.12.26-.26V8.492a3.779 3.779 0 01-2.332-.986l-.148-.146-.14-.15zm3.837-5.71H2.287l-.66 3.72c-.01.08-.02.17-.02.25 0 .85.73 1.53 1.64 1.53 1.14 0 2.07-.87 2.07-1.93 0-.96 1.48-1 1.6-.12l.02.27c.08.99.97 1.78 2.06 1.78s1.99-.79 2.07-1.78l.01-.27c.13-.88 1.6-.84 1.6.12 0 1.06.93 1.93 2.08 1.93.09 0 .17-.01.26-.02.89-.14 1.5-.92 1.35-1.76l-.65-3.72z" _fill="#FFF" fill-rule="evenodd"/>'
  }
})
